import {
    getPriceChangeScope,
    getSuggestedStoreIds,
    PRICE_CHANGE_SCOPE,
} from './priceChangeScope';

export type RequestZoneCostFields = {
    zoneHighestCostPrice?: number | null;
    cashbuildCostPrice?: number | null;
    pnlCostPrice?: number | null;
    storeCostPrice?: number | null;
    costPrice?: number | null;
    priceChangeScope?: string | null;
    suggestedStoreIds?: string[] | null;
    completed?: boolean | null;
};

function finiteOrNull(value?: number | null): number | null {
    if (value == null || !Number.isFinite(value)) {
        return null;
    }
    return value;
}

export function getRequestZoneHighestCostPrice(
    request: RequestZoneCostFields,
): number | null {
    return (
        finiteOrNull(request.zoneHighestCostPrice) ??
        finiteOrNull(request.costPrice)
    );
}

export function isSingleSuggestedStoreRequest(
    request: object | null | undefined,
): boolean {
    const completed =
        request != null &&
        'completed' in request &&
        Boolean((request as RequestZoneCostFields).completed);

    return (
        getPriceChangeScope(request) === PRICE_CHANGE_SCOPE.SPECIFIC_STORES &&
        getSuggestedStoreIds(request).length === 1 &&
        !completed
    );
}

export function getRequestEffectiveCostPrice(
    request: RequestZoneCostFields,
): number | null {
    const usesSelectedStores =
        getPriceChangeScope(request) === PRICE_CHANGE_SCOPE.SPECIFIC_STORES &&
        getSuggestedStoreIds(request).length > 0 &&
        !request.completed;

    if (usesSelectedStores) {
        return (
            finiteOrNull(request.costPrice) ??
            getRequestZoneHighestCostPrice(request)
        );
    }

    if (
        getPriceChangeScope(request) === PRICE_CHANGE_SCOPE.STORE &&
        !request.completed
    ) {
        return (
            finiteOrNull(request.storeCostPrice) ??
            getRequestZoneHighestCostPrice(request)
        );
    }

    return getRequestZoneHighestCostPrice(request);
}

export function getRequestCashbuildCostPrice(
    request: RequestZoneCostFields,
): number | null {
    return (
        finiteOrNull(request.cashbuildCostPrice) ??
        getRequestZoneHighestCostPrice(request)
    );
}

export function getRequestPnlCostPrice(
    request: RequestZoneCostFields,
): number | null {
    return (
        finiteOrNull(request.pnlCostPrice) ??
        getRequestZoneHighestCostPrice(request)
    );
}

export function getRequestStoreCostPrice(
    request: RequestZoneCostFields,
): number | null {
    return finiteOrNull(request.storeCostPrice);
}
